// extracted by mini-css-extract-plugin
export var checkbox = "styles-module--checkbox--24Ugx";
export var checked = "styles-module--checked--GYZZK";